import {Injectable} from "@angular/core";
import {MasterAsideService} from "../../../../../tramitantes/src/app/services/aside/master-aside.service";
import {IContainerAsideComponent} from "../../../../../tramitantes/src/app/shared/interfaces/configuracion";

@Injectable()
export class SisbenAsideService extends MasterAsideService {


  getMenuItems(translations: any, isLoggedIn: boolean, props?: any): IContainerAsideComponent[] {
    return [
      {
        visible: isLoggedIn,
        class: 'mt-3',
        items: [
          {
            index: 0,
            title: 'Consulta SISBEN',
            content: 'Consulta tu puntaje, miembros del hogar y más información relacionada con el SISBEN',
            icon: 'pi  pi-credit-card',
            descripcionCard: 'Consultas sobre Sisben',
            command: (event: any) => props.redirect('/tramites/consulta-sisben'),
          },
        ]
      }
    ]

  }

}
